import axios from 'axios'

import { BASE_URL } from 'constants/misc'
import { getCheckinAuthHeader } from 'utils/checkinAuth'
import { CHECKIN_USER_DATA } from 'utils/loginStorage'

import { camelizeResponseInterceptor, decamelizeRequestInterceptor } from './utils/interceptors'

export interface TruckbookApiResponse<T, M = unknown> {
  status: string
  data: T
  meta?: M
  message: string | null
}

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  const authHeaders = getCheckinAuthHeader(CHECKIN_USER_DATA)
  Object.entries(authHeaders).forEach(([key, value]) => {
    config.headers.set(key, value)
  })
  return decamelizeRequestInterceptor(config)
})

apiClient.interceptors.response.use(camelizeResponseInterceptor)
